import * as types from "./types";

export default {
  [types.TOGGLE_HOME](state, visibility) {
    state.modals.showHome = visibility;
  },
  [types.TOGGLE_ABOUT](state, visibility) {
    state.modals.showAbout = visibility;
  },
  [types.TOGGLE_SCIENCE](state, visibility) {
    state.modals.showScience = visibility;
  },
  [types.SET_ACTIVE_MENUS](state, payload) {
    state.activeMenus.top = payload.top;
    state.activeMenus.mid = payload.mid;
    state.activeMenus.bottom = payload.bottom;
  },
  [types.RESET_SECTOR_MENU](state) {
    state.activeMenus.mid = 0;
  },
  [types.TOGGLE_LOADING](state, visibility) {
    state.loading = visibility;
  },
  [types.SET_BIOLOGICAL_RESULT](state, biologicalResult) {
    state.scToolsResults.biological = biologicalResult;
  },
  [types.SET_MARINE_ENERGY_RESULT](state, marineEnergyResult) {
    state.scToolsResults.marineEnergy = marineEnergyResult;
  },
  [types.SET_HINDCAST_DATA](state, hindcastDataResult) {
    state.hindcastDataResult = hindcastDataResult;
  },
  [types.SET_BTM_DATAHUB_ACTIVE_PANEL](state, panel) {
    state.btmDatahubActivePanel = panel;
  },
  [types.SET_BTM_DATAHUB_ACTIVE_MOMENT](state, moment) {
    state.btmDatahubActiveMoment = moment;
  },
  [types.SET_BTM_BLUEGROWTH_ACTIVE_PANEL](state, panel) {
    state.btmBlueGrowthActivePanel = panel;
  },
  [types.SET_BTM_TOOLS_ACTIVE_PANEL](state, panel) {
    state.btmToolsActivePanel = panel;
  },
  [types.SET_BTM_TOOLS_ACTIVE_TOOL](state, tool) {
    state.btmToolsActiveTool = tool;
  },
  [types.SET_ACTIVE_PRODUCT](state, product) {
    state.activeProduct = product;
  },
  [types.SET_ACTIVE_DEVICE](state, device) {
    state.activeDevice = device;
  },
  [types.SET_BLUEGROWTH_OPERATIVITY_INPUTS](state, payload) {
    state.bluegrowth.operativity.variables = payload.variables;
    state.bluegrowth.operativity.products = payload.products;
  }
};
